import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../../src/utill/validation";
import { Row, Space } from "antd";
import axios from "axios";
import api from "../../../src/config.json";
import Table from "../../../src/Common/table";
import dateTime from "../../../src/utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../../src/utill/Excelimport";
import Loading from "../../../src/utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import moment from "moment";
import { Tabs } from "antd";
import { generateExcelFile } from "../../utill/download";

const { TabPane } = Tabs;
const CompoundMaster = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });

  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Operation, setOperation] = useState({});
  const [componentList, setcomponentList] = useState([]);
  const [modelState, setmodelState] = useState(false);
  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });
  const [modelState1, setmodelState1] = useState(false);
  const [QRCodeArray, SetQRCodeArray] = useState([]);

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [PartName, setPartName] = useState("");
  const [PartNumber, setPartNumber] = useState("");
  const [PdfData, setPdfData] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [NumOfStickers, setNumOfStickers] = useState(0);
  const [StickerNumber, setStickerNumber] = useState(0);

  const [Inputdata, setInputData] = useState({});
  const [PrintType, setPrintType] = useState("New");

  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'QRCode' values
    const updatedList = componentList.map((one) => ({
      ...one,
      QRCode: isChecked,
    }));

    // Update state
    setcomponentList(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };
  const handelOnPDfEnable = (e, input) => {
    let data = [...componentList];

    if (e.currentTarget.checked) {
      // QRCode the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, QRCode: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, QRCode: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, QRCode: false } : item;
      });
    }
    setcomponentList(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const columns = [
    {
      key: "select",
      label: (
        <input
          type="checkbox"
          onChange={handelSelectAll}
          checked={
            componentList.filter(
              (one) => one.QRCode == false || one.QRCode == undefined
            ).length > 0
              ? false
              : true
          }
        />
      ),
      content: (obj) => (
        <input
          type="checkbox"
          checked={obj["QRCode"]}
          onChange={(e) => handelOnPDfEnable(e, obj)}
        />
      ),
    },
    // { path: "Name", label: "Name" },
    { path: "CompoundCode", label: "Compound Code" },
    { path: "LastGeneratedTag", label: "Last Generated Tag" },
    { path: "PolymerType", label: " Expected Polymer Type",content: (obj) => <label>{obj.PolymerType && obj.PolymerType.join(', ')}</label>},

    {
      path: "createdAt",
      label: "Created Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      path: "updatedAt",
      label: "Last Updated Date",
      content: (obj) => (
        <React.Fragment>
          <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
          <br />
        </React.Fragment>
      ),
    },
    {
      key: "update",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => {
            // setOperation(user)
            setUpdate(user);
            setopStatus("update");
          }}
          className="btn btn-sm btn-primary"
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
    // { key: 'view', content: user => <button onClick={() => onView(user)} className="btn btn-sm btn-info"><FontAwesomeIcon icon={faEye} /></button> },
    {
      key: "delete",
      content: (user) => (
        <button
          disabled={
            !getRightsForAccess("StaticDataRights", RightName, "update")
          }
          onClick={() => onDelete(user)}
          className="btn btn-sm btn-danger"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      ),
    },
  ];
  function generateCountingArray(targetNumber) {
    // Convert the input to a number to ensure proper handling
    targetNumber = parseInt(targetNumber, 10);

    if (isNaN(targetNumber) || targetNumber < 0) {
      console.error("Please provide a valid positive number.");
      return [];
    }

    // Get the maximum padding length based on the input number
    const maxPadding = targetNumber.toString().length;

    // Initialize the result array
    const result = [];

    for (let i = 1; i <= targetNumber; i++) {
      // Correctly pad the number with leading zeros
      const paddedNumber = String(i).padStart(3, "0");

      // Push the object into the array
      result.push({ Name: `Number ${paddedNumber}`, Value: paddedNumber });
    }

    return result;
  }

  // Example usage

  useEffect(() => {
    if (opStatus == "update") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setOperation(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  useEffect(() => {
    Heading("Compound Code Master");
    // getCompundList();
    getRMTypeMaster();
    getToolList();
  }, []);

  useEffect(() => {
    const data = [...PdfData];
    const pdf = [];
    console.log(data, "curent data");

    if (PrintType == "Existing") {
      data.map((one) => {
        if (one.QRCode) {
          // Ensure QRCode is present

          [...Array(Math.min(1))].forEach((_, j) => {
            pdf.push({
              QrCode: JSON.stringify({
                CC: one.CompoundCode,
                QT: one.Qty,
                UID: one.UniqueID,
                STag: StickerNumber, // Use formatted tag
              }),
              index: j,
              BatchNo: one.BatchNo,
              CompoundCode: one.CompoundCode,
              TracebilityNo: one.TracebilityNo,
              LastGeneratedTag: StickerNumber, // Add formatted tag here too
              STag: one.LastGeneratedTag,
              UniqueID: one.UniqueID,
              NumOfStickers: 1,
            });
          });
        }
      });
    } else {
      data.map((one) => {
        if (one.QRCode) {
          // Ensure QRCode is present
          let currentTag = parseInt(one.LastGeneratedTag, 10) || 1; // Convert to number, fallback to 0 if invalid

          [...Array(Math.min(NumOfStickers))].forEach((_, j) => {
            const formattedTag = String(currentTag).padStart(3, "0"); // Format with leading zeros (3 digits)

            pdf.push({
              QrCode: JSON.stringify({
                CC: one.CompoundCode,
                QT: one.Qty,
                UID: one.UniqueID,
                STag: formattedTag, // Use formatted tag
              }),
              index: j,
              BatchNo: one.BatchNo,
              CompoundCode: one.CompoundCode,
              TracebilityNo: one.TracebilityNo,
              LastGeneratedTag: formattedTag, // Add formatted tag here too
              STag: one.LastGeneratedTag,
              UniqueID: one.UniqueID,
              NumOfStickers: NumOfStickers,
            });

            currentTag += 1; // Increment for the next iteration
          });
        }
      });
    }
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    // setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  }, [NumOfStickers, PrintType, StickerNumber]);

  const getCompundList = () => {
    axios
      .get(api.api + "compoundMaster")
      .then((result) => {
        setTemplateList(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getToolList = () => {
    axios
      .get(api.api + "compoundMaster")
      .then((result) => {
        setcomponentList(result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const downloadPDF = async (qrCodeGroups, Operation,PageClassName) => {
    console.log("vfdkhbdfhkbgdfh", qrCodeGroups, Operation);
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName(PageClassName)[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save("CompoundCode_Master.pdf");
  };

  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };

  const handleSort = (sortColumn) => {
    if (componentList.length > 0) {
      const sorted = _.orderBy(
        componentList,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);
      setcomponentList(sorted);
    }
  };

  const schema = {
    CompoundCode: joi.string().required(),
    QRCode: joi.boolean(),
    LastGeneratedTag: joi.string(),
    Enable:joi.boolean(),
    UniqueID:joi.string(),
    PolymerType: joi.array().min(1).required(),
    _id: joi.string(),
  };

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;

    setOperation((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOnChange1 = (e) => {
    const { value } = e.currentTarget;

    setPartName(value); // Merges the new value with the previous string
  };
  const handleOnChange2 = (e) => {
    const { value } = e.currentTarget;

    setPartNumber(value); // Merges the new value with the previous string
  };
  const handleOnAdd = () => {
    const test = { ...Operation };
    if (PartName.length > 0) {
      test.PartName = [...(test.PartName || []), PartName];
      setPartName("");
      setOperation(test);
    } else {
      swal("Can Not Add Blank Part Name");
    }
    // Add PartName (string) to the array in test.PartName
  };
  const handleOnAdd1 = () => {
    const test = { ...Operation };
    if (PartNumber.length > 0) {
      test.PartNumber = [...(test.PartNumber || []), PartNumber];
      setPartNumber("");
      setOperation(test);
    } else {
      swal("Can Not Add Blank Part Name");
    }
    // Add PartName (string) to the array in test.PartName
  };
  const getRMTypeMaster = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        const data = result.data.filter((item) => item.RM_Type === "Polymer");
        console.log(data, "fljfbejfv");
        const list = data.map((one) => ({
          Name: one.RM_ID,
          value: one.RM_ID,
        }));

        setTemplateList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const removeRow = (index) => {
    // Create a deep copy of the `Operation` state to avoid direct mutation
    let data = { ...Operation, PartName: [...Operation.PartName] };

    // Remove the item at the specified index
    data.PartName.splice(index, 1);

    // Update the state with the modified data
    setOperation(data);
  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };
  const downloadPDFforAll = (data) => {
    const pdf = [];
    data.map(
      (one) =>
        one.QRCode &&
        [...Array(Math.min(NumOfStickers))].forEach((_, j) => {
          pdf.push({
            QrCode: JSON.stringify({
              CC: one.CompoundCode,
              // BN: one.BatchNo,
              // TC: one.TracebilityNo,
              // MD: moment(one.MixingDate).format("DD-MM-YY"),
              // ED: moment(one.ExpiryDate).format("DD-MM-YY"),
              QT: one.Qty,
              UID: one.UniqueID,
              LastGeneratedTag: one.LastGeneratedTag,
            }),
            index: j,
            BatchNo: one.BatchNo,
            CompoundCode: one.CompoundCode,
            TracebilityNo: one.TracebilityNo,
            LastGeneratedTag: one.LastGeneratedTag,
            STag: one.LastGeneratedTag,

            UniqueID: one.UniqueID,
            NumOfStickers: NumOfStickers,
          });
        })
    );

    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "compoundMaster/" + data._id, { data: data })
          .then((result) => {
            getToolList();
            swal("Deleted  Successfully");
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };

  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handleCloseModel1 = () => {
    setopStatus("");
    setStickerNumber(0);
    setNumOfStickers(0);
    setPrintType("New");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setStickerNumber(0);
    setNumOfStickers(0);
    setmodelState1(false);
    setPrintType("New");
  };

  const handleSaveData1 = (data, numberOfStickers, data2, data3) => {
    const test = data.find((one) => one.QRCode === true);

    if (!test) {
      console.error("No item with QRCode found");
      return;
    }

    let LastGeneratedTag = test.LastGeneratedTag; // Initial value as a string
    // Convert to number, add the value, and pad with zeros
    let newTag = (parseInt(LastGeneratedTag, 10) + parseInt(numberOfStickers))
      .toString()
      .padStart(3, "0");
    test.LastGeneratedTag = newTag;
    const checksheet = { ...test };
    console.log(checksheet, "eklhkhcgecgeh", newTag, test);

    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);

    //   return;
    // }
    // return

    setLoader(true);

    axios
      .patch(api.api + "compoundMaster/" + checksheet._id, checksheet)
      .then((result) => {
        swal("Data Updated Successfully");
        getToolList();
        setQRCodeVisible(true);
        handleCloseModel();
        handleCloseModel1();
        setLoader(false);
        setStickerNumber(0);
        setNumOfStickers(0);
      })
      .catch((err) => {
        if (err.response && err.response.data) {
          swal(err.response.data.message, { dangerMode: true });
        }
        console.log(err);
        setLoader(false);
      });
  };
  const handelSaveData = (data) => {
    const checksheet = { ...data };
    delete checksheet.__v;
    delete checksheet.createdAt;
    delete checksheet.updatedAt;
    const errors = validation.validate(checksheet, schema);
    if (errors) {
      alert(JSON.stringify(errors));
      seterrors(errors);
      return;
    }
    setLoader(true);
    if (opStatus == "update") {
      axios
        .patch(api.api + "compoundMaster/" + Update._id, checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          getToolList();
          setQRCodeVisible(true);

          handleCloseModel();
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "compoundMaster", checksheet)
        .then((result) => {
          swal("Data Saved Successfully");
          getToolList();
          handleCloseModel();
          setQRCodeVisible(true);

          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

      <Modal
        className="custom-modal1"
        size={size}
        show={modelState}
        onHide={handleHideModel}
        backdrop={"static"}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center">
            Compound Code Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Operation${id}`}> */}
          <Row className="">
            {/* <Col sm={3}>
              <div className="form-group form-group-sm">
                <label htmlFor="operationRejectionCost">Batch No</label>
                <input
                  required
                  onChange={handleOnChange}
                  style={{ width: "100%" }}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm"
                  type="text"
                  // min="0"
                  name="BatchNo"
                  value={Operation.BatchNo}
                />
                {errors.BatchNo && <div className="alert small alert-danger">{errors['BatchNo']}</div>}
              </div>
            </Col>
           */}
            {/* <Col sm={12}>
              <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost " className="fw-bold">
                  {" "}
                  Compond Name{" "}
                </label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100"
                  type="text"
                  name="Name"
                  value={Operation.Name}
                  placeholder="Enter Compound Code"
                />
                {errors.Name && (
                  <div className="alert small alert-danger">
                    {errors["Name"]}
                  </div>
                )}
              </div>
            </Col> */}
            <Col sm={12}>
              <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost " className="fw-bold">
                  {" "}
                  Compond Code{" "}
                </label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100"
                  type="text"
                  name="CompoundCode"
                  value={Operation.CompoundCode}
                  placeholder="Enter Compound Code"
                />
                {errors.CompoundCode && (
                  <div className="alert small alert-danger">
                    {errors["CompoundCode"]}
                  </div>
                )}
              </div>
            </Col>

            <Col sm={12}>
              <div className="form-group mt-2 ">
                <div className="" htmlFor="operationRejectionCost">
                  Expected Polymer Type
                </div>
                <div className="">
                  <AntdSelect
                   multiple={true}
                   mode="multiple"
                    placeholder="Select  Expected Polymer Type."
                    onChange={(value) => {
                      const template = templateList.find(
                        (x) => x.Name == value
                      );
                      setSelectedTemplate(template || {});
                      handleOnChange({
                        currentTarget: { name: "PolymerType", value: value },
                      });
                    }}
                    value={Operation.PolymerType || []}
                    style={{ width: "100%" }}
                  >
                    {templateList.map((one) => {
                      return (
                        <AntdSelect.Option value={one.Name}>
                          {one.Name}
                        </AntdSelect.Option>
                      );
                    })}
                  </AntdSelect>
                </div>

                {errors.PolymerType && (
                  <div className="alert small alert-danger">
                    {errors["PolymerType"]}
                  </div>
                )}
              </div>
            </Col>
            {/* <Col sm={12}>
              <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost" className="fw-bold">Qr Code</label>
                <input
                  required
                  onChange={handleOnChange}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100"
                  type="text"
                  name="QrCode"
                  value={Operation.QrCode}
                  placeholder="Enter Qr Code"

                />
                {errors.QrCode && (
                  <div className="alert small alert-danger">
                    {errors["QrCode"]}
                  </div>
                )}
              </div>
            </Col> */}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel()}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              const error = validateCheckCheckPoints(rows);
              if (error.IsError) {
                swal("ERROR", error.message.join(", "), { dangerMode: true });
              } else {
                handelSaveData(Operation);
              }
            }}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="d-flex float-left mb-2">
        {PdfData && PdfData.length > 0 && EnableAllPdf && (
          <button
            type="button"
            className="btn-sm btn-primary ml-2 mt-2"
            onClick={() => downloadPDFforAll(PdfData)}
          >
            Generate PDFs
          </button>
        )}
        {
          <button
            disabled={
              !getRightsForAccess("StaticDataRights", RightName, "write")
            }
            className="btn-sm btn-success ml-2 mt-2"
            onClick={() => {
              setmodelState(true);
              setOperation({});
              setUpdate({});
              setSelectedTemplate({});
            }}
          >
            Create New Compound Code
          </button>
        }
        {/* <button type="button" className="btn-sm btn-primary  mx-2" 
    onClick={()=>handleUploadGuagesDoc()}
    >
      <FontAwesomeIcon icon={faFileImport} /> Import Excel</button>  */}
        <Modal
          backdrop={"static"}
          className=""
          size={size}
          show={modelState1}
          onHide={handleHideModel1}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              Compound Code Master
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

            {console.log(Inputdata.NumOfStickers, "snsdonsdn")}
            <div className="a4-sheet">
              <div className="">
                <div className="card-container">
                  <Tabs
                    onTabClick={(key) => {
                      if (key === "1") {
                        setPrintType("New");
                      } else {
                        const filter = PdfData.filter(
                          (one) => one.QRCode == true
                        );
                        if (filter.length > 1) {
                          swal("Please Select One Compound Code");
                        } else {
                          setPrintType("Existing");
                        }
                      }
                    }}
                    type="card"
                  >
                    <TabPane tab="Create New" key="1">
                      <div className="form-group form-group-sm d-flex flex-column">
                        <label
                          htmlFor="operationRejectionCost "
                          className="fw-bold"
                        >
                          {" "}
                          Number Of Stickers{" "}
                        </label>
                        <input
                          required
                          onChange={(e) =>
                            setNumOfStickers(e.currentTarget.value)
                          }
                          //disabled={cycleTimeRadioState === 1 ? false : true}
                          className="form-control form-control-sm w-100"
                          type="number"
                          name="CompoundCode"
                          min={1}
                          value={NumOfStickers}
                          placeholder="Enter Number Of Stickers"
                        />
                        {/* {errors.CompoundCode && (
<div className="alert small alert-danger">
{errors["CompoundCode"]}
</div>
)} */}
                      </div>
                      {
                        QRCodeArray && QRCodeArray.length > 0 && (
                          <div>
                            <Button
                              type="primary"
                              onClick={() => {
                                downloadPDF(QRCodeArray, Inputdata,"a4-page");
                                handleSaveData1(
                                  PdfData,
                                  NumOfStickers,
                                  QRCodeArray,
                                  Inputdata
                                );
                              }}
                              style={{ marginBottom: "16px" }}
                            >
                              Download as PDF
                            </Button>

                            <div
                              style={{ overflowY: "scroll", height: "72vh" }}
                              className=""
                            >
                              {QRCodeArray.map((group, index) => (
                                <div className="a4-sheet-scrollable">
                                  <div
                                    className="a4-page"
                                    // key={pageIndex}
                                    style={{ pageBreakAfter: "always" }}
                                  >
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: `repeat(${Math.sqrt(
                                          16
                                        )}, 1fr)`, // 3 columns in each row
                                        gridTemplateRows: `repeat(${Math.sqrt(
                                          16
                                        )}, auto)`, // 3 rows per page (auto height)
                                        gap: "57px", // Optional: Adjust the gap between items as needed
                                        justifyItems: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      {group.map((one, index) => (
                                        <div
                                          className="d-flex flex-column justify-content-center align-items-center "
                                          key={index}
                                          style={{
                                            textAlign: "center",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          <QRCodeSVG
                                            value={one.QrCode}
                                            level={"M"}
                                            size={80}
                                            style={{ marginBottom: "3px" }}
                                          />{" "}
                                          {/* Adjust the size of the QR code */}
                                          <p
                                            style={{
                                              fontSize: "9px",
                                              color: "black",
                                              letterSpacing: "0.5px",
                                              lineHeight: "1.2",
                                            }}
                                            className="bolder p-0 m-0"
                                          >
                                            {`${
                                              one.UniqueID +
                                              "-" +
                                              one.LastGeneratedTag
                                            } `}
                                            <br />
                                            {one.CompoundCode}

                                            <br />
                                            {`${one.LastGeneratedTag} `}
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )
                        // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
                        //   <Space className="qr-space" key={index} direction="vertical" align="center">
                        //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
                        //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
                        //   </Space>
                        // ))
                      }
                    </TabPane>
                    <TabPane tab="Reprint Existing" key="2">
                      <div className="form-group form-group-sm d-flex flex-column">
                        <div className=" form-group text-center">
                          <div className="text-center "> Sticker Number </div>
                          <AntdSelect
                            disabled={opStatus === "view"}
                            placeholder="Select Sticker Number"
                            onChange={(value) => {
                              setStickerNumber(value);
                            }}
                            value={StickerNumber || ""}
                            style={{ width: "100%" }}
                            showSearch // Enables the search functionality
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            } // Custom filter logic
                          >
                            {generateCountingArray(
                              QRCodeArray[0] &&
                                QRCodeArray[0][0] &&
                                QRCodeArray[0][0].STag
                            ).map((one) => (
                              <AntdSelect.Option
                                key={one.Value}
                                value={one.Value}
                              >
                                {one.Value}
                              </AntdSelect.Option>
                            ))}
                          </AntdSelect>
                        </div>
                      </div>
                      {
                        QRCodeArray && QRCodeArray.length > 0 && (
                          <div>
                            <Button
                              type="primary"
                              onClick={() => {
                                downloadPDF(QRCodeArray, Inputdata,"a4-page1");
                              }}
                              style={{ marginBottom: "16px" }}
                            >
                              Download as PDF
                            </Button>

                            <div
                              style={{ overflowY: "scroll", height: "72vh" }}
                              className=""
                            >
                              {QRCodeArray.map((group, index) => (
                                <div className="a4-sheet-scrollable">
                                  <div
                                    className="a4-page1"
                                    // key={pageIndex}
                                    style={{ pageBreakAfter: "always" }}
                                  >
                                    <div
                                      style={{
                                        display: "grid",
                                        gridTemplateColumns: `repeat(${Math.sqrt(
                                          16
                                        )}, 1fr)`, // 3 columns in each row
                                        gridTemplateRows: `repeat(${Math.sqrt(
                                          16
                                        )}, auto)`, // 3 rows per page (auto height)
                                        gap: "57px", // Optional: Adjust the gap between items as needed
                                        justifyItems: "center",
                                        alignItems: "center",
                                      }}
                                    >
                                      {group.map((one, index) => (
                                        <div
                                          className="d-flex flex-column justify-content-center align-items-center "
                                          key={index}
                                          style={{
                                            textAlign: "center",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          <QRCodeSVG
                                            value={one.QrCode}
                                            level={"M"}
                                            size={80}
                                            style={{ marginBottom: "3px" }}
                                          />{" "}
                                          {/* Adjust the size of the QR code */}
                                          <p
                                            style={{
                                              fontSize: "9px",
                                              color: "black",
                                              letterSpacing: "0.5px",
                                              lineHeight: "1.2",
                                            }}
                                            className="bolder p-0 m-0"
                                          >
                                            {`${
                                              one.UniqueID +
                                              "-" +
                                              one.LastGeneratedTag
                                            } `}
                                            <br />
                                            {one.CompoundCode}

                                            <br />
                                            {`${one.LastGeneratedTag} `}
                                          </p>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )
                        // [...Array(Number(Inputdata.NumOfStickers))].map((_, index) => (
                        //   <Space className="qr-space" key={index} direction="vertical" align="center">
                        //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
                        //     <p>{index + 1 + ' / ' + Inputdata.NumOfStickers}</p>
                        //   </Space>
                        // ))
                      }
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => handleCloseModel1()}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {getRightsForAccess("StaticDataRights", RightName, "write") && (
          <Excelimport
            getToolList={getToolList}
            API={"compoundMaster"}
            handelUpdate={() => getToolList()}
          />
        )}
        <div className="">
          <button
            onClick={() => handleDownloadExcel("CompoundCodeTemplate")}
            className="btn-sm btn-primary ml-2 mt-2"
          >
            Download Template
          </button>
        </div>
        <div style={{ display: "none" }}>
          <table id="CompoundCodeTemplate">
            <thead>
              <tr class>
                <th>CompoundCode</th>

                <th>PolymerType</th>
              </tr>
            </thead>
          </table>
        </div>
      </div>

      {componentList.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={componentList}
        />
      )}
    </>
  );
};

export default CompoundMaster;
